<template lang="">
    <div class="section-cv">
         <div class="heading2-section cv">
            Skills
        </div>

        <div class="section-context skills">
            <div class="skill" v-for="skill in skills" :key="skill.skillId">{{skill.name}}</div>
        </div>
    </div>
</template>
<script>
export default {
    computed:{
        skills(){
            var skls = this.$store.getters["cvbuilder/getCVInformation"]?.skills || [];
            return skls;
        }
    }
}
</script>
<style scoped>
    .skills{
        display: grid;
        grid-template-columns: repeat(3,1fr);
        column-gap:1rem;
        margin-bottom:1rem;
    }

    @media(max-width: 768px){
        .skill{
            white-space: nowrap;
            overflow-x: hidden;
            text-overflow: ellipsis;
        }
    }
</style>